import { render, staticRenderFns } from "./RepVentas.vue?vue&type=template&id=3e40dd9f&"
import script from "./RepVentas.vue?vue&type=script&lang=js&"
export * from "./RepVentas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports